import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { useTenant } from '@emerald-works-nova/auth'
import { useStyles } from './style'
import { Box, Slide } from '@mui/material'
import { b2cSignupSlice } from '../../../reducers'
import PaywallCTA from './components/cta'
import PaywallTrustAndPartners from './components/trust-partners'
import { fetchPlans } from '../../../reducers/b2c-signup/slice'
import { formatAmount } from '../../../pages/b2c-signup/components/utils'
import consts from '../../../consts'

const Paywall = () => {
  const dispatch = useDispatch()
  const [paywallOpen, setPaywallOpen] = useState(false)

  const classes = useStyles()
  const tenant = useTenant()
  const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK

  const plan = useSelector(b2cSignupSlice.selectors.selectPlan)
  const planPrice = formatAmount(plan?.price?.currency, plan?.price?.unitAmount) || null

  useEffect(() => {
    setTimeout(() => setPaywallOpen(true), 3000)
  }, [])

  useEventsOnViewLoad(() => {
    dispatch(fetchPlans())
  }, [dispatch])

  if (!isClubTenant || !planPrice) return null

  return (
    <Slide
      direction='up' in={paywallOpen} timeout={1500} easing={{
        enter: 'cubic-bezier(0, 0.55, 0.45, 1)'
      }} mountOnEnter unmountOnExit
    >
      <Box className={classes.banner} data-test='paywall-banner'>
        <Box className={classes.container} data-test='paywall-banner'>
          <PaywallCTA />
          <Box className={classes.desktopBackground}>
            <PaywallTrustAndPartners />
          </Box>
        </Box>
      </Box>
    </Slide>
  )
}

export default Paywall
